import { render } from "./BaseCard.vue?vue&type=template&id=1f9750d9&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=1f9750d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f9750d9"

export default script